import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const PurchaseAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHavePurchaseAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            purchase: {
              isHaveAddAccess: true,
              isHaveViewAccess: true,
              isHaveExportAccess: true,
              isHaveDeleteAccess: true,
              isHaveEditAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            purchase: {
              isHaveAddAccess: false,
              isHaveViewAccess: false,
              isHaveExportAccess: false,
              isHaveDeleteAccess: false,
              isHaveEditAccess: false,
            },
          }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHavePurchaseAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      purchase: { ...j.purchase, [name]: checked },
    }));
  };
  return (
    <Collapse in={featuresAccess.isHavePurchaseAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveViewAccess")}
          checked={
            (featuresAccess.purchase &&
              featuresAccess.purchase.isHaveViewAccess) ||
            false
          }
          name={"isHaveViewAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.purchase &&
              featuresAccess.purchase.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveEditAccess")}
          checked={
            (featuresAccess.purchase &&
              featuresAccess.purchase.isHaveEditAccess) ||
            false
          }
          name={"isHaveEditAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.purchase &&
              featuresAccess.purchase.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />

        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.purchase &&
              featuresAccess.purchase.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default PurchaseAccess;
